import DepartmentsStaff from './DepartmentsStaff';

export default DepartmentsStaff;
